import { useMutation } from "react-query";
import API from "../../Config/axios";

const onUpdatePatient = async (queueId, payload) => {
  const { data } = await API.post(`/queues/${queueId}`, payload);
  return data;
};

const useUpdateQueue = () => {
  return useMutation(({ queueId, payload }) =>
    onUpdatePatient(queueId, payload)
  );
};

export default useUpdateQueue;
